export const CREDENTIAL_TYPE = {
  ACCESS_KEY: 'ACCESS_KEY',
  RENEWAL_KEY: 'RENEWAL_KEY',
};

export const KA_QUEUE = {
  PROCESS: 'process',
  PREPARE: 'prepare',
};
